import React from 'react';

export default function ResultFooterNote({ isSuccess, isPending }) {
  if (isSuccess) {
    return (
      <p className="text-center text-sm text-gray-500 mt-6">
        A confirmation has been logged. Please arrive 10 minutes before your booking time.
      </p>
    );
  }

  if (!isPending) {
    return (
      <p className="text-center text-sm text-gray-500 mt-6">
        If you were charged, the amount will be refunded within 5-7 business days.
        Please contact support if you need assistance.
      </p>
    );
  }

  return null;
}
